<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';
import { useUserVariablesStore } from '@/store/userVariables';
import { useStyleStore } from '@/store/styleStore';


const userVariablesStore = useUserVariablesStore();
const styleStore = useStyleStore();
const translation = computed(() => userVariablesStore.currentLanguageData);

const omnibusHintVisible = computed(() => {
  const setting = styleStore.styles?.omnibusHintVisible as unknown as
    | { value?: boolean | string }
    | undefined;
  const value = setting?.value;

  return typeof value === 'string' ? value.toLowerCase() !== 'false' : value !== false;
});


</script>

<template>
  <div v-if="omnibusHintVisible" class="omnibus-hint omnibus-hint-background">
    <div class="flex flex-row items-center gap-2">
      <div class="omnibus-hint__icon omnibus-hint-icon">
        <FontAwesomeIcon icon="fa-solid fa-circle-info" />
      </div>

      <p class="omnibus-hint__text omnibus-hint-text" v-html="translation?.staticTexts?.omnibusHint || 'Translation missing'">
      </p>
    </div>
  </div>
</template>

<style scoped>
.omnibus-hint {
  margin-inline: -1rem;
  margin-top: -1rem;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  width: calc(100% + 2rem);
}

.omnibus-hint-background {
  background-color: #e5e5e5;
}

@media (min-width: 601px) {
  .omnibus-hint {
    margin-inline: -2rem;
    margin-top: -2rem;
    width: calc(100% + 4rem);
  }
}

.omnibus-hint__icon {
  display: block;
  margin-bottom: 0.2rem;

  font-size: 0.8rem;
  font-weight: 600;
}

.omnibus-hint-icon {
  color: #404040;
}

.omnibus-hint__text {
  margin: 0;

  font-size: 0.75rem;
  line-height: 1.4;
}

.omnibus-hint-text {
  color: #404040;
  font-family: inherit;
}
</style>
